const CANVAS_KEYBOARD_OWNING_OVERLAY_SELECTOR = '[aria-modal="true"], [data-canvas-escape-owner]';

/**
 * Same gate as Escape: an open modal or floating panel (tools catalog, asset picker)
 * owns the keyboard, so canvas shortcuts must not steal Backspace/Delete. Queried live
 * because overlay presence is dynamic.
 */
export const hasCanvasKeyboardOwningOverlay = (): boolean =>
  document.querySelector(CANVAS_KEYBOARD_OWNING_OVERLAY_SELECTOR) !== null;
